import { clientAuth } from './axios';

const login = ({ ...body }) => clientAuth.post(`/admin/login`, body);

export const accountService = {
  login,
};
